export type ParsedAddress = {
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
};

type AddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

type PlaceResult = {
  address_components?: AddressComponent[];
};

export const parseAddressComponents = (place: PlaceResult): ParsedAddress => {
  const addressComponents: AddressComponent[] = place.address_components || [];
  const result: ParsedAddress = {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
  };

  const getComponent = (
    types: string[],
    longName = false
  ): string | undefined => {
    const component = addressComponents.find((comp) =>
      types.some((type) => comp.types.includes(type))
    );
    return component
      ? longName
        ? component.long_name
        : component.short_name
      : undefined;
  };

  const streetNumber = getComponent(['street_number']);
  const route = getComponent(['route']);
  const subpremise = getComponent(['subpremise']);

  if (streetNumber && route) {
    result.line1 = `${streetNumber} ${route}`.trim();
  } else if (route) {
    result.line1 = route;
  } else if (streetNumber) {
    result.line1 = streetNumber;
  }

  if (subpremise) {
    result.line2 = subpremise;
  }

  const city =
    getComponent(['sublocality'], true) ||
    getComponent(['locality'], true) ||
    getComponent(['postal_town'], true) ||
    '';
  result.city = city;

  const state = getComponent(['administrative_area_level_1'], true) || '';
  result.state = state;

  const postalCode = getComponent(['postal_code'], true) || '';
  result.postalCode = postalCode;

  const country = getComponent(['country']) || '';
  result.country = country;

  return result;
};
